import { render, staticRenderFns } from "./ticketsKanban.vue?vue&type=template&id=230f823d&"
import script from "./ticketsKanban.vue?vue&type=script&lang=ts&"
export * from "./ticketsKanban.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports